import { option } from 'fp-ts';
import { flow } from 'fp-ts/function';
import { get } from 'lodash/fp';
import { createSelector } from 'reselect';

import { getOrFalse } from '@mews/fp';

import { parentSelector } from '../../../selectors/parentSelector';
import { ApplicationState } from '../../../types';
import { SummaryState } from './reducer';

const getSummary = createSelector<ApplicationState, ApplicationState, SummaryState>(parentSelector, get('summary'));

export const isSummaryPreparing = createSelector(getSummary, getOrFalse('isPreparing'));
export const hasSummaryPreparationFailed = createSelector(getSummary, getOrFalse('hasPreparationFailed'));

export const getFetchReservationPricesTimeoutId = flow(
    getSummary,
    ({ fetchReservationPricesTimeoutId }) => fetchReservationPricesTimeoutId,
    option.fromNullable
);

export const hasFetchReservationPricesPendingRequest = flow(getFetchReservationPricesTimeoutId, option.isSome);
